/* prettier-ignore */

import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, Injector } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ToolsService } from 'src/app/services/tools.service';
import { MailIconComponent } from 'src/chatbot/icons/mail-icon.component';
import { MinimizeIconComponent } from 'src/chatbot/icons/minimize-icon.component';
import { FullScreenIconComponent } from 'src/chatbot/icons/full-screen-icon.component';
import { NormalScreenIconComponent } from 'src/chatbot/icons/normal-screen-icon.component';
import { dataChatService } from 'src/chatbot/service/dataChat.service';
import { ModalController } from '@ionic/angular';
import { ChatBotInfoComponent } from '../chatBotInfo/chatBotInfo.component';
import { SendMailComponent } from '../sendMail/sendMail.component';
import { ReloadIconComponent } from 'src/chatbot/icons/reload-icon.component';
import { StatisticsService } from 'src/app/services/statistics.service';
import { WebSocketService } from 'src/chatbot/service/webSocket.service';
import { RegisterFormService } from 'src/chatbot/service/chat-actions/register-form.service';
import { NewCustomRouteService } from 'src/app/pages/new-custom-route/new-custom-route.service';
import { Router } from '@angular/router';

@Component({
  selector: 'chat-header',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    MinimizeIconComponent,
    FullScreenIconComponent,
    MailIconComponent,
    NormalScreenIconComponent,
    ReloadIconComponent,
  ],
  templateUrl: './chatHeader.component.html',
  styleUrl: './chatHeader.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatHeaderComponent {
    private statisticsService = inject(StatisticsService)
    private webSocketService = inject(WebSocketService)
    public toolsService = inject(ToolsService)
    public dataChatService = inject(dataChatService);
    private registerFormService = inject(RegisterFormService)
    private customRouteService = inject(NewCustomRouteService);
    private router = inject(Router);
    public logoSrc = computed(() => this.dataChatService.icon())
    public chatName = computed(() => this.dataChatService.name())
    public isFullScreen = computed(() => this.dataChatService.isFullScreen())
    public hasSaveChat = computed(() => this.dataChatService.hasSaveChat())
    public canSaveChat = computed(() => this.dataChatService.canSaveChat())
    public isNew = computed(() => this.dataChatService.isNew());

    private modalController = inject(ModalController)
    private modal: any;

    toggleView(){
        this.dataChatService.hideChat.update(prev => !prev);
        if (this.dataChatService.hideChat()) 
          this.dataChatService.isFullScreen.set(false)
    }

    resetChat(){
      window.location.reload();
      return;
      
      if (this.router.url?.includes('custom-route') || this.router?.url?.includes('send-update-route'))
        this.router.navigateByUrl('/home');

      this.webSocketService.disconnect();
      this.webSocketService.historyChat = [];
      const newToken = this.statisticsService.generateNewSessionId();
      this.dataChatService.token.set(newToken);
      this.dataChatService.messages.set([]);
      this.dataChatService.hasHistory.set(false);
      this.dataChatService.requestIsFulliled.set(false);
      this.webSocketService.connectAll();
      this.registerFormService.resetLocalStorage();
      this.registerFormService.resetForm();
      this.customRouteService.resetRoute();
      // this.dataChatService.resetChat();
    }

    toggleFullScreen(){
      this.dataChatService.isFullScreen.update(prev => !prev);
    }

    toggleAction(action){
      switch(action){
        case 'email': 
          if (!this.canSaveChat()) return;
          this.openModal(SendMailComponent); 
          break;
        case 'info': this.openModal(ChatBotInfoComponent); break;
      }
    }

    async openModal(component) {
      if (this.modal) return;
      this.modal = await this.modalController.create({
        component: component,
        cssClass: ['chatBotModal', 'ion-disable-focus-trap'],
        componentProps: {},
      });
      await this.modal.present();
      await this.modal.onDidDismiss();
      this.modal = null;
    }


}